import tenFour from "@/assets/hub/reaction-ten-four.png.asset.json";
import hammerDown from "@/assets/hub/reaction-hammer-down.png.asset.json";
import moneyLane from "@/assets/hub/reaction-money-lane.png.asset.json";
import loaded from "@/assets/hub/reaction-loaded.png.asset.json";
import greenLight from "@/assets/hub/reaction-green-light.png.asset.json";

/**
 * LR HUB freight reactions — positive-only set, rendered from the uploaded
 * transparent PNG pack (CDN assets, NOT generated icons).
 *
 * One reaction per user per post (see `hub_post_reactions`): picking a new
 * type replaces the old one, picking the same type again removes it.
 */

export type HubReactionType =
  | "ten_four"
  | "hammer_down"
  | "money_lane"
  | "loaded"
  | "green_light";

export interface HubReactionDef {
  type: HubReactionType;
  label: string;
  src: string;
}

/** Order matters: the first entry is the default quick-tap reaction. */
export const HUB_REACTIONS: HubReactionDef[] = [
  { type: "ten_four", label: "10-4", src: tenFour.url },
  { type: "hammer_down", label: "Hammer Down", src: hammerDown.url },
  { type: "money_lane", label: "Money Lane", src: moneyLane.url },
  { type: "loaded", label: "Loaded", src: loaded.url },
  { type: "green_light", label: "Green Light", src: greenLight.url },
];

export const DEFAULT_HUB_REACTION: HubReactionType = "ten_four";

/**
 * Warm the browser cache for all 5 PNGs at module load so the hover picker
 * never paints half-decoded / zero-size images on first open.
 */
if (typeof window !== "undefined") {
  for (const r of HUB_REACTIONS) {
    const img = new Image();
    img.src = r.src;
  }
}


export const HUB_REACTION_BY_TYPE: Record<HubReactionType, HubReactionDef> =
  HUB_REACTIONS.reduce((acc, r) => {
    acc[r.type] = r;
    return acc;
  }, {} as Record<HubReactionType, HubReactionDef>);

export type HubReactionCounts = Partial<Record<HubReactionType, number>>;

export function hubReactionTotal(counts: HubReactionCounts | null | undefined): number {
  if (!counts) return 0;
  return Object.values(counts).reduce((a, b) => a + (b ?? 0), 0);
}

/** Types present on a post, in the canonical display order. */
export function hubPresentReactions(counts: HubReactionCounts | null | undefined): HubReactionDef[] {
  if (!counts) return [];
  return HUB_REACTIONS.filter((r) => (counts[r.type] ?? 0) > 0);
}
